document.addEventListener('DOMContentLoaded', () => {
  const countdowns = document.querySelectorAll('[data-raid-countdown]');

  countdowns.forEach((countdown) => {
    const targetValue = countdown.getAttribute('data-countdown-target');

    const days = countdown.querySelector('[data-days]');
    const hours = countdown.querySelector('[data-hours]');
    const minutes = countdown.querySelector('[data-minutes]');
    const seconds = countdown.querySelector('[data-seconds]');

    if (!days || !hours || !minutes || !seconds) return;

    const pad = (value) => String(value).padStart(2, '0');

    const zeroCountdown = () => {
      days.textContent = '00';
      hours.textContent = '00';
      minutes.textContent = '00';
      seconds.textContent = '00';
    };

    if (!targetValue || targetValue === 'LIVE') {
      zeroCountdown();
      return;
    }

    const targetDate = new Date(targetValue).getTime();

    if (Number.isNaN(targetDate)) {
      zeroCountdown();
      return;
    }

    const renderCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        zeroCountdown();
        return;
      }

      const totalSeconds = Math.floor(distance / 1000);

      days.textContent = pad(Math.floor(totalSeconds / 86400));
      hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    };

    renderCountdown();
    setInterval(renderCountdown, 1000);
  });
});